import { render } from "./SalesforceContactForm.vue?vue&type=template&id=8aafbe64&scoped=true&ts=true"
import script from "./SalesforceContactForm.vue?vue&type=script&lang=ts"
export * from "./SalesforceContactForm.vue?vue&type=script&lang=ts"

import "./SalesforceContactForm.vue?vue&type=style&index=0&id=8aafbe64&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aafbe64"]])

export default __exports__